import './index.css';
import { jsx } from 'react/jsx-runtime';
import { useRef, useLayoutEffect } from 'react';
import { useScrollContext } from './ScrollableContainer.js';
import 'classnames';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-breakpoint';
import '@hh.ru/magritte-ui-dot-pages';
import '@hh.ru/magritte-ui-icon/icon';
import './useScrollContainer-C2IuMKOL.js';
import '@hh.ru/magritte-internal-custom-scroll';
import './types.js';
import './utils.js';
import '@hh.ru/magritte-ui-spacing';

const ScrollableItem = ({ children, ...props }) => {
    const ref = useRef(null);
    const { registerItem, removeItem, scrollToItem } = useScrollContext();
    useLayoutEffect(() => {
        registerItem(ref);
        return () => removeItem(ref);
    }, [registerItem, removeItem]);
    return (jsx("div", { ref: ref, onClick: () => scrollToItem(ref), ...props, children: children }));
};

export { ScrollableItem };
//# sourceMappingURL=ScrollableItem.js.map
